import React, {useState} from 'react'


import { CheckCircleOutline } from '@mui/icons-material'
import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import { addizionaleInUso } from './utils/funzioni';
import { Avatar } from '@mui/material';
import { Tooltip } from '@mui/material';
import { useContext } from 'react';
import StatoComparatoreContext from './contexts/StatoComparatore'
import { Popper } from '@mui/material';
import { useRef } from 'react';
import { Chip } from '@mui/material';
import { Card } from '@mui/material';
import { Box } from '@mui/material';
import { getContrastRatio } from '@mui/material';

const {logger} = useBSSLogger();


const AvatarAddizionale = ({addizionale, preventivo, disablePopper = false}) => {

    const {methods, addizionaliById, categoriaById, setStatoPopperAddizionale} = useContext(StatoComparatoreContext)
    const inUso = addizionaleInUso(preventivo, addizionale, methods, addizionaliById);
    const utilizzato = inUso?.utilizzato ?? false
    const labelAddizionale = categoriaById?.[addizionale?.id]?.codice ?? (addizionale?.nome?.testo) ?? ""
    const title = spedizioniweb2.ucfirst((labelAddizionale).toLowerCase());
    const inUsoText = utilizzato ? ` - ${__t("attivo")}` : "";
    logger.debug("addizionale in suo title", addizionale, inUsoText, utilizzato, inUso)
    const textTitle = `${title} ${inUsoText}`
    const bgcolor = spedizioniweb2.colorReducer(title);
    const textColor = getContrastRatio("#fff", bgcolor) >= getContrastRatio("#000", bgcolor) ? "#fff" : "#000"
    logger.debug("colore ottenuto dal title", title, bgcolor)

    const showPopper = (e) => {
        !disablePopper && setStatoPopperAddizionale({
            open: true,
            anchorEl: e.currentTarget,
            title: (
                <Chip sx={{backgroundColor: bgcolor, color: textColor}}
                    title={textTitle}
                    icon={utilizzato !== false ? (
                        <CheckCircleOutline fontSize="small" sx={{color: `${textColor} !important`}} />
                    ): undefined}
                    label={
                        <>
                            {title} 
                        </>
                    } 
                />
            ),
            bgcolor
        })
    }

    const hidePopper = (e) => {
        !disablePopper && setStatoPopperAddizionale({
            open: false,
            anchorEl: null,
            title: null,
            bgcolor: null
        })
    }

    const conditionalProps = {
        ...(disablePopper ? 
            {title: textTitle} : {
                onMouseDown: showPopper,
                onMouseOver: showPopper,
                onTouchStart: showPopper,
                onMouseOut: hidePopper,
                onMouseUp: hidePopper,
            })
    }

    return (
        <>
            <Avatar                                
                    variant="rounded"
                    sx={{bgcolor, pl: 0.3, height: "30px"}}
                    {...conditionalProps}
                >
                    {labelAddizionale[0]} {utilizzato && (
                        <CheckCircleOutline fontSize='small' style={{fontSize: "15px"}} />
                    )}
            </Avatar>
        </>
    )


    {/* <Typography variant="subtitle2" className={classes.pricesubtitle} >
        {__t("servizidisponibili")}{" "}
        {listaaddizionali.map((addizionale, indiceAddizionale) => {

            const inUso = addizionaleInUso(preventivo, addizionale, methods, addizionaliById);
            const labelAddizionale = categoriaById?.[addizionale?.id]?.codice ?? (addizionale?.nome?.testo) ?? ""
            const title = spedizioniweb2.ucfirst((labelAddizionale).toLowerCase());

            
            return (                                    
                
                <Hidden mdDown key={indiceAddizionale}>
                    <Chip  
                        title={title}
                        icon={(inUso?.utilizzato ?? false) !== false ? (
                            <CheckCircleOutline fontSize="small" />
                        ): undefined}

                        color="primary"

                        label={
                            <>
                                {title} 
                            </>
                        } 
                    />
                    {" "}
                </Hidden>
            )
        })}
                                                                                                        
    </Typography> */}
}

export default AvatarAddizionale;